import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultStateTaxData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'state-tax-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'item-estate',
              type: 'PresentationListItem',
              props: {
                title: 'State Estate Tax',
                description:
                  "In addition to the federal estate tax, some states impose their own estate tax. State estate tax is deductible from federal estate tax, but the exemption amounts and tax rates vary widely from state to state.\n\nState estate tax rates are typically progressive, meaning they increase with the value of the estate. Rates can range from as low as 0.8% to as high as 20%. It's important for individuals to be aware of their specific state's estate tax laws to avoid unexpected tax liabilities and to plan effectively for the future.",
                iconType: 'institution',
                iconColor: 'NEGATIVE',
              },
            },
            {
              id: 'item-inheritance',
              type: 'PresentationListItem',
              props: {
                title: 'State Inheritance Tax',
                description:
                  'Unlike estate tax, which is levied on the estate itself, some states impose an inheritance tax on the beneficiaries receiving the estate assets. Inheritance tax is deductible from federal estate tax, but the tax rates and rules vary by state and often depend on the relationship between the decedent and the beneficiary.\n\nSpouses typically receive an exemption from inheritance tax, and some states also exempt children or close relatives. The tax rates usually increase for more distant relatives and non-relatives.',
                iconType: 'institution',
                iconColor: 'NEGATIVE',
              },
            },
          ],
        },
      },
    ],
  };
}
